import { api } from "lib";
import apiFormData from "lib/apiFormData";
const GET_COMMON_TYPE_LINK = "/v1/dropdown/getCommonTypeByGroupType";

export const getPendingLeaveRequest = async (params = {}) => {
  return await api.post(
    "/v1/requestApprove/getLeaveRequestApprovePaging",
    params
  );
};

export const getWorkflowByRequestId = async (params) => {
  return await api.post("/v1/leaveRequest/getWorkflowByRequestId", params);
};


export const getPendingOffsiteWorkRequest = async (params = {}) => {
  return await api.post(
    "/v1/requestApprove/getOffsiteWorkRequestApprovePaging",
    params
  );
};

export const getPendingRedeemTimeRequest = async (params = {}) => {
  return await api.post(
    "/v1/requestApprove/getRedeemTimeRequestApprovePaging",
    params
  );
};

export const getPendingEndorseTimeRequest = async (params = {}) => {
  return await api.post(
    "/v1/requestApprove/getEndorseTimeRequestApprovePaging",
    params
  );
};

export const getPendingOvertimeRequest = async (params = {}) => {
  return await api.post(
    "/v1/requestApprove/getOvertimeRequestApprovePaging",
    params
  );
};

export const getPendingCollectTimeRequest = async (params = {}) => {
  return await api.post(
    "/v1/requestApprove/getCollectTimeRequestApprovePaging",
    params
  );
};

export const getRequestHistory = async (params = {}) => {
  return await api.post(
    "/v1/requestApprove/getLeaveRequestApprovePaging",
    params
  );
};


export const manageMyLeaveRequestStatus = async (params) => {
  return await api.post("/v1/leaveRequest/manageMyLeaveRequestStatus", params);
};

export const approveLeaveRequest = async (params) => {
  return await apiFormData.post("/v1/requestApprove/createLeaveRequestApprove", params);
};

export const approveOffsiteWorkRequest = async (params) => {
  return await apiFormData.post("/v1/requestApprove/createOffsiteWorkRequestApprove", params);
};

export const approveOvertimeRequest = async (params) => {
  return await apiFormData.post("/v1/requestApprove/createOvertimeRequestApprove", params);
};

export const approveCollectTimeRequest = async (params) => {
  return await apiFormData.post("/v1/requestApprove/createCollectTimeRequestApprove", params);
};

export const approveWarningLetterRequest = async (params) => {
  return await apiFormData.post("/v1/requestApprove/createWarningLetterRequestApprove", params);
};

export const approveEndorseTimeRequest = async (params) => {
  return await apiFormData.post("/v1/requestApprove/createEndorseTimeRequestApprove", params);
};

export const approveChangeShiftRequest = async (params) => {
  return await apiFormData.post("/v1/requestApprove/createChangeShiftRequestApprove", params);
};

export const approveDocumentRequest = async (params) => {
  return await apiFormData.post("/v1/requestApprove/createDocumentRequestApprove", params);
};

export const approveRedeemTimeRequest = async (params) => {
  return await apiFormData.post("/v1/requestApprove/createRedeemTimeRequestApprove", params);
};

export const approveExpenseRequest = async (params) => {
  return await apiFormData.post("/v1/requestApprove/createExpenseApprove", params);
};

export const approveandRejectExpenseRequest = async (params) => {
  return await apiFormData.post("/v1/expense/approveTxnExpense", params);
};

export const pendingApproveExpense = async (params = {}) => {
  return await api.post(
    "/v1/requestApprove/pendingApproveExpense",
    params
  );
};

export const getPendingExpensePaging = async (params = {}) => {
  return await api.post(
    "/v1/expense/getExpenseForApprover",
    params
  );
};

export const getCompanyRegulationOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getCompanyRegulation", {
    companyId: params.companyId,
  });
};



export const manageOffsiteWorkRequestStatus = async (params) => {
  return await api.post(
    "/v1/offsiteWorkRequest/manageOffsiteWorkRequestStatus",
    params
  );
};

export const manageRedeemTimeRequestStatus = async (params) => {
  return await api.post(
    "/v1/redeemTimeRequest/manageRedeemTimeRequestStatus",
    params
  );
};

export const manageEndorseTimeRequestStatus = async (params) => {
  return await api.post(
    "/v1/EndorseTimeRequest/manageEndorseTimeRequestStatus",
    params
  );
};

export const manageOvertimeRequestStatus = async (params) => {
  return await api.post(
    "/v1/overtimeRequest/manageOvertimeRequestStatus",
    params
  );
};

export const manageCollectTimeRequestStatus = async (params) => {
  return await api.post(
    "/v1/collectTimeRequest/manageCollectTimeRequestStatus",
    params
  );
};


export const getPendingWarningLetterRequest = async (params = {}) => {
  return await api.post(
    "/v1/requestApprove/getWarningLetterRequestApprovePaging",
    params
  );
};

export const manageWarningLetterRequestStatus = async (params) => {
  return await api.post(
    "/v1/warningLetterRequest/manageWarningLetterRequestStatus",
    params
  );
};
export const getWarningLetterRequestById = async (params) => {
  return await api.post(
    "/v1/warningLetterRequest/getWarningLetterRequest",
    params
  );
};
export const getWarningLetterByIdRequest = async (params) => {
  return await api.post(
    "/v1/warningLetterRequest/getWarningLetterRequest",
    params
  );
};
export const manageDocumentRequestStatus = async (params) => {
  return await api.post(
    "/v1/collectTimeRequest/manageDocumentRequestStatus",
    params
  );
};

export const getPendingDocumentRequest = async (params = {}) => {
  return await api.post(
    "/v1/requestApprove/getDocumentRequestApprovePaging",
    params
  );
};

export const getPendingChangeShiftRequest = async (params = {}) => {
  return await api.post(
    "/v1/requestApprove/getChangeShiftRequestApprovePaging",
    params
  );
};

export const approveWarningLetter = async (params = {}) => {
  return await apiFormData.post(
    "/v1/requestApprove/createWarningLetterRequestApprove",
    params
  );
};

export const approveMovement = async (params = {}) => {
  return await apiFormData.post(
    "/v1/requestApprove/createMovementApprove",
    params
  );
};

export const getPendingMovement = async (params = {}) => {
  return await api.post(
    "/v1/movement/getMovementRequestApprovePaging",
    params
  );
};

export const getLeaveGroupIsLeaveApproval = async (params = {}) => {
  return await api.post("/v1/dropdown/getLeaveCategoryGroupIsLeaveApproval", params);
};

export const getLeaveCategoryGroupIsLeaveApprovalAllActive = async (params = {}) => {
  return await api.post("/v1/dropdown/getLeaveCategoryGroupIsLeaveApprovalAllActive", params);
};

export const getDropDown = async (params = {}) => {
  return await api.post("/v1/dropdown/getEmployee", params);
};

export const getLeaveGroupIsOffSite = async (params = {}) => {
  return await api.post("/v1/dropdown/getLeaveCategoryGroupIsOffsite", params);
};

export const getDocumentTypeOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getDocumentType", params);
};

export const getPenaltiesOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "PENALTY",
  });
};

export const getMovementGroup = async (params = {}) => {
  return await api.post("/v1/dropdown/getMovementGroup", params);
};

export const getMyTxnExpenseById = async (params = {}) => {
  return await api.post("/v1/expense/getTxnExpenseById", params);
};